import React from 'react';
import { Card } from '../components/ui/Card';
import { StatsCard } from '../components/ui/StatsCard';
import { UsersIcon, WalletIcon, HomeIcon, ClipboardListIcon, TrendingUpIcon, AlertCircleIcon } from 'lucide-react';
export const Dashboard = () => {
  return <div className="space-y-6" data-id="element-465">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between" data-id="element-466">
        <div data-id="element-467">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-468">Dashboard</h1>
          <p className="mt-1 text-sm text-gray-500" data-id="element-469">
            Welcome to the College ERP System Dashboard
          </p>
        </div>
        <div className="mt-4 md:mt-0" data-id="element-470">
          <div className="inline-flex items-center space-x-2 bg-indigo-50 text-indigo-700 px-3 py-1.5 rounded-full text-sm" data-id="element-471">
            <span className="w-2 h-2 rounded-full bg-indigo-600" data-id="element-472"></span>
            <span data-id="element-473">Academic Year: 2023-24</span>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-474">
        <StatsCard title="Total Students" value="1,248" icon={<UsersIcon size={20} className="text-indigo-600" data-id="element-476" />} trend={{
        value: 12,
        isPositive: true
      }} color="indigo" data-id="element-475" />
        <StatsCard title="Fee Collection" value="₹24.5L" icon={<WalletIcon size={20} className="text-green-600" data-id="element-478" />} trend={{
        value: 8,
        isPositive: true
      }} color="green" data-id="element-477" />
        <StatsCard title="Hostel Occupancy" value="82%" icon={<HomeIcon size={20} className="text-orange-600" data-id="element-480" />} trend={{
        value: 3,
        isPositive: false
      }} color="orange" data-id="element-479" />
        <StatsCard title="Exam Pass Rate" value="76%" icon={<ClipboardListIcon size={20} className="text-blue-600" data-id="element-482" />} trend={{
        value: 5,
        isPositive: true
      }} color="blue" data-id="element-481" />
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-483">
        <Card title="Recent Admissions" className="lg:col-span-2" data-id="element-484">
          <div className="overflow-x-auto -mx-5 px-5" data-id="element-485">
            <table className="min-w-full divide-y divide-gray-200" data-id="element-486">
              <thead data-id="element-487">
                <tr data-id="element-488">
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-489">
                    Student
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-490">
                    ID
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-491">
                    Course
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-492">
                    Date
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-493">
                    Status
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-100" data-id="element-494">
                {[{
                name: 'Rahul Sharma',
                id: 'ST2023001',
                course: 'B.Tech CSE',
                date: 'Aug 12, 2023',
                status: 'Confirmed'
              }, {
                name: 'Priya Patel',
                id: 'ST2023014',
                course: 'BBA',
                date: 'Aug 11, 2023',
                status: 'Pending'
              }, {
                name: 'Amit Kumar',
                id: 'ST2023022',
                course: 'B.Sc Physics',
                date: 'Aug 10, 2023',
                status: 'Confirmed'
              }, {
                name: 'Neha Singh',
                id: 'ST2023035',
                course: 'B.Com',
                date: 'Aug 09, 2023',
                status: 'Confirmed'
              }, {
                name: 'Vikram Joshi',
                id: 'ST2023041',
                course: 'B.Tech ECE',
                date: 'Aug 08, 2023',
                status: 'Pending'
              }].map((student, index) => <tr key={index} className="hover:bg-gray-50" data-id="element-495">
                    <td className="px-4 py-3.5 whitespace-nowrap" data-id="element-496">
                      <div className="flex items-center" data-id="element-497">
                        <div className="h-9 w-9 rounded-full bg-indigo-100 flex items-center justify-center text-indigo-700 font-medium text-sm" data-id="element-498">
                          {student.name.split(' ').map(n => n[0]).join('')}
                        </div>
                        <div className="ml-3" data-id="element-499">
                          <div className="text-sm font-medium text-gray-900" data-id="element-500">
                            {student.name}
                          </div>
                        </div>
                      </div>
                    </td>
                    <td className="px-4 py-3.5 whitespace-nowrap text-sm text-gray-500" data-id="element-501">
                      {student.id}
                    </td>
                    <td className="px-4 py-3.5 whitespace-nowrap text-sm text-gray-500" data-id="element-502">
                      {student.course}
                    </td>
                    <td className="px-4 py-3.5 whitespace-nowrap text-sm text-gray-500" data-id="element-503">
                      {student.date}
                    </td>
                    <td className="px-4 py-3.5 whitespace-nowrap" data-id="element-504">
                      <span className={`px-2.5 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${student.status === 'Confirmed' ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'}`} data-id="element-505">
                        {student.status}
                      </span>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </Card>
        <Card title="Notifications" className="lg:col-span-1" data-id="element-506">
          <div className="space-y-1 -mx-5" data-id="element-507">
            {[{
            title: 'Fee Deadline Approaching',
            message: 'Semester fees due in 5 days for 120 students',
            icon: <AlertCircleIcon size={16} className="text-red-500" data-id="element-508" />,
            time: '2 hours ago',
            color: 'bg-red-50'
          }, {
            title: 'New Admission Applications',
            message: '15 new applications received today',
            icon: <TrendingUpIcon size={16} className="text-green-500" data-id="element-509" />,
            time: '5 hours ago',
            color: 'bg-green-50'
          }, {
            title: 'Hostel Room Allocation',
            message: 'Room allocation completed for Boys Hostel Block C',
            icon: <HomeIcon size={16} className="text-blue-500" data-id="element-510" />,
            time: 'Yesterday',
            color: 'bg-blue-50'
          }, {
            title: 'Exam Results Published',
            message: 'Semester 4 results published for all departments',
            icon: <ClipboardListIcon size={16} className="text-purple-500" data-id="element-511" />,
            time: '2 days ago',
            color: 'bg-purple-50'
          }].map((notification, index) => <div key={index} className={`flex items-start p-4 hover:bg-gray-50 border-l-4 ${notification.color === 'bg-red-50' ? 'border-red-400' : notification.color === 'bg-green-50' ? 'border-green-400' : notification.color === 'bg-blue-50' ? 'border-blue-400' : 'border-purple-400'} cursor-pointer transition-colors duration-200`} data-id="element-512">
                <div className={`flex-shrink-0 mr-3 p-2 rounded-lg ${notification.color}`} data-id="element-513">
                  {notification.icon}
                </div>
                <div data-id="element-514">
                  <p className="text-sm font-medium text-gray-900" data-id="element-515">
                    {notification.title}
                  </p>
                  <p className="text-xs text-gray-500 mt-1" data-id="element-516">
                    {notification.message}
                  </p>
                  <p className="text-xs text-gray-400 mt-1.5 flex items-center" data-id="element-517">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-3.5 h-3.5 mr-1" data-id="element-518">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm.75-13a.75.75 0 00-1.5 0v5c0 .414.336.75.75.75h4a.75.75 0 000-1.5h-3.25V5z" clipRule="evenodd" data-id="element-519" />
                    </svg>
                    {notification.time}
                  </p>
                </div>
              </div>)}
          </div>
        </Card>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-520">
        <Card title="Fee Collection Status" data-id="element-521">
          <div className="h-64 flex items-center justify-center" data-id="element-522">
            <div className="space-y-6 w-full max-w-md" data-id="element-523">
              <div className="relative pt-1" data-id="element-524">
                <div className="flex items-center justify-between mb-2" data-id="element-525">
                  <div className="flex items-center" data-id="element-526">
                    <span className="w-3 h-3 rounded-full bg-indigo-600 mr-2" data-id="element-527"></span>
                    <span className="text-sm font-medium text-gray-700" data-id="element-528">
                      B.Tech
                    </span>
                  </div>
                  <div className="text-right" data-id="element-529">
                    <span className="text-sm font-semibold inline-block text-indigo-600" data-id="element-530">
                      ₹12.5L/₹15.2L (82%)
                    </span>
                  </div>
                </div>
                <div className="overflow-hidden h-2.5 mb-4 text-xs flex rounded-full bg-indigo-100" data-id="element-531">
                  <div style={{
                  width: '82%'
                }} className="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-indigo-600 rounded-full" data-id="element-532"></div>
                </div>
              </div>
              <div className="relative pt-1" data-id="element-533">
                <div className="flex items-center justify-between mb-2" data-id="element-534">
                  <div className="flex items-center" data-id="element-535">
                    <span className="w-3 h-3 rounded-full bg-green-600 mr-2" data-id="element-536"></span>
                    <span className="text-sm font-medium text-gray-700" data-id="element-537">
                      BBA
                    </span>
                  </div>
                  <div className="text-right" data-id="element-538">
                    <span className="text-sm font-semibold inline-block text-green-600" data-id="element-539">
                      ₹4.7L/₹5.0L (94%)
                    </span>
                  </div>
                </div>
                <div className="overflow-hidden h-2.5 mb-4 text-xs flex rounded-full bg-green-100" data-id="element-540">
                  <div style={{
                  width: '94%'
                }} className="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-green-600 rounded-full" data-id="element-541"></div>
                </div>
              </div>
              <div className="relative pt-1" data-id="element-542">
                <div className="flex items-center justify-between mb-2" data-id="element-543">
                  <div className="flex items-center" data-id="element-544">
                    <span className="w-3 h-3 rounded-full bg-orange-500 mr-2" data-id="element-545"></span>
                    <span className="text-sm font-medium text-gray-700" data-id="element-546">
                      B.Sc
                    </span>
                  </div>
                  <div className="text-right" data-id="element-547">
                    <span className="text-sm font-semibold inline-block text-orange-600" data-id="element-548">
                      ₹3.4L/₹5.0L (68%)
                    </span>
                  </div>
                </div>
                <div className="overflow-hidden h-2.5 mb-4 text-xs flex rounded-full bg-orange-100" data-id="element-549">
                  <div style={{
                  width: '68%'
                }} className="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-orange-500 rounded-full" data-id="element-550"></div>
                </div>
              </div>
              <div className="relative pt-1" data-id="element-551">
                <div className="flex items-center justify-between mb-2" data-id="element-552">
                  <div className="flex items-center" data-id="element-553">
                    <span className="w-3 h-3 rounded-full bg-blue-600 mr-2" data-id="element-554"></span>
                    <span className="text-sm font-medium text-gray-700" data-id="element-555">
                      B.Com
                    </span>
                  </div>
                  <div className="text-right" data-id="element-556">
                    <span className="text-sm font-semibold inline-block text-blue-600" data-id="element-557">
                      ₹3.8L/₹5.0L (76%)
                    </span>
                  </div>
                </div>
                <div className="overflow-hidden h-2.5 mb-4 text-xs flex rounded-full bg-blue-100" data-id="element-558">
                  <div style={{
                  width: '76%'
                }} className="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-blue-600 rounded-full" data-id="element-559"></div>
                </div>
              </div>
            </div>
          </div>
        </Card>
        <Card title="Hostel Occupancy Status" data-id="element-560">
          <div className="h-64 flex items-center justify-center" data-id="element-561">
            <div className="grid grid-cols-2 gap-8 w-full max-w-md" data-id="element-562">
              <div className="text-center" data-id="element-563">
                <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-blue-100 mb-4 relative" data-id="element-564">
                  <HomeIcon size={32} className="text-blue-600" data-id="element-565" />
                  <div className="absolute -right-1 -top-1 bg-blue-600 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs font-medium" data-id="element-566">
                    M
                  </div>
                </div>
                <h4 className="text-lg font-semibold text-gray-900" data-id="element-567">
                  Boys Hostel
                </h4>
                <div className="mt-2 flex items-center justify-center" data-id="element-568">
                  <div className="relative w-24 h-24" data-id="element-569">
                    <svg viewBox="0 0 36 36" className="w-24 h-24" data-id="element-570">
                      <path d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" fill="none" stroke="#E2E8F0" strokeWidth="3" data-id="element-571" />
                      <path d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" fill="none" stroke="#3B82F6" strokeWidth="3" strokeDasharray="94, 100" strokeLinecap="round" data-id="element-572" />
                    </svg>
                    <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center flex-col" data-id="element-573">
                      <span className="text-2xl font-bold text-blue-600" data-id="element-574">
                        94%
                      </span>
                    </div>
                  </div>
                </div>
                <p className="text-sm text-gray-500 mt-2" data-id="element-575">470/500 Occupied</p>
              </div>
              <div className="text-center" data-id="element-576">
                <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-purple-100 mb-4 relative" data-id="element-577">
                  <HomeIcon size={32} className="text-purple-600" data-id="element-578" />
                  <div className="absolute -right-1 -top-1 bg-purple-600 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs font-medium" data-id="element-579">
                    F
                  </div>
                </div>
                <h4 className="text-lg font-semibold text-gray-900" data-id="element-580">
                  Girls Hostel
                </h4>
                <div className="mt-2 flex items-center justify-center" data-id="element-581">
                  <div className="relative w-24 h-24" data-id="element-582">
                    <svg viewBox="0 0 36 36" className="w-24 h-24" data-id="element-583">
                      <path d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" fill="none" stroke="#E2E8F0" strokeWidth="3" data-id="element-584" />
                      <path d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" fill="none" stroke="#9333EA" strokeWidth="3" strokeDasharray="78, 100" strokeLinecap="round" data-id="element-585" />
                    </svg>
                    <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center flex-col" data-id="element-586">
                      <span className="text-2xl font-bold text-purple-600" data-id="element-587">
                        78%
                      </span>
                    </div>
                  </div>
                </div>
                <p className="text-sm text-gray-500 mt-2" data-id="element-588">312/400 Occupied</p>
              </div>
            </div>
          </div>
        </Card>
      </div>
    </div>;
};